import { Component } from '@angular/core';

@Component({
    template: '<router-outlet></router-outlet>',
    selector: 'app-root',
    standalone: false,
})
export class AppRootComponent {}
